import { SET_HOME_USER, SET_PROJECT_LIST, SET_PROJECT_USER, UserActionTypes } from '../actionTypes';
import { IUserState } from '../stateTypes';

const initialState: IUserState = {
    homeUser: null,
    projectUser: null,
    projectList: null,
}

export function userReducer(
    state = initialState,
    action: UserActionTypes
): IUserState {
    if (action.type === SET_HOME_USER) {
        return {
            ...state,
            homeUser: action.payload
        };
    }
    if (action.type === SET_PROJECT_USER) {
        return {
            ...state,
            projectUser: action.payload
        };
    }
    if (action.type === SET_PROJECT_LIST) {
        return {
            ...state,
            projectList: action.payload
        };
    }
    return state;
}